
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { filter } from 'lodash';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';


export class SelectMultipleWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    large: PropTypes.bool,
    emptyValue: PropTypes.any,
  };

  static defaultProps = {
    value: [],
    large: false,
    emptyValue: []
  };

  handleChange = (event) => {
    const options = event.target.value;
    const { onChange, emptyValue } = this.props;
    if (options && options.length > 0) {
      onChange(options);
    }
    else {
      onChange(emptyValue);
    }
  };

  isValueSelected = (checkedValue) => {
    const { value } = this.props;
    return value.indexOf(checkedValue) > 0;
  };

  render() {
    const { value, options } = this.props;

    let selectedValues = [];
    if (value !== null && value !== undefined && value !== []) {
      selectedValues = filter(options, function (o) {
        return value.indexOf(o.value) !== -1;
      });
    }

    return (
      <Select
        multiple
        value={value || []}
        onChange={(e) => this.handleChange(e)}
        input={<Input id="select-multiple-chip" />}
        renderValue={(selected) => (
          <div>
            {selectedValues.map((option) => (
              <Chip key={option.value} label={option.label} />
            ))}
          </div>
        )}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={value.indexOf(option.value) > -1} />
            {option.label}
          </MenuItem>
        ))}
      </Select>
    );
  }
}
